module.exports = __webpack_public_path__ + "static/10-355b894623f50e54cdcf499873f6f558.jpg";